<template>
  <div>
    <exo-table :root="_self" disableEditionActions enableUnarchiveDeleteActions>
      <template v-slot:titleTooltip>
        <exo-help-dialog margin="m-0 mt-1 ml-2" title="Archives">
          <h5>Presentation</h5>
          The archiving mechanism has been designed to keep your workspace clean
          and tidy. Any mission can be archived from the mission board in the
          main window. Once a mission is archived, it is no longer displayed
          inside the mission board. It can be retrieved later in the "Archive"
          window, accessible from the user menu in the navigation bar.
          <br />
          <br />
          <h5>Technical notes</h5>
          When archiving a mission, a copy is made that includes a copy of all
          used objects. Once the mission is archived, the original mission and
          obsolete objects are automatically deleted.
          <br />
          <br />
          An archived mission is independent from the other missions. This means
          that the objects used inside an archived mission are not shared by any
          other mission.
          <br />
          <br />
          Note that mission results are not archived. A new computation will be
          in order after unarchiving a mission.
        </exo-help-dialog>
      </template>
    </exo-table>
    <v-col ref="missionTableErrorDisplay"> </v-col>
  </div>
</template>

<script>
import errorMixin from '../mixins/logHandler.js'
import fieldsDescription from '../tools/fieldsDescription.json'
import dataTools from '../tools/data.js'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Archives',
  mixins: [errorMixin],

  async mounted() {
    this.resetCurrentMission()
    this.$root.$on('mission-list-updated', this.missionListUpdatedHandler)
  },

  beforeDestroy() {
    this.$root.$off('mission-list-updated', this.missionListUpdatedHandler)
  },

  computed: {
    ...mapGetters({ currentUser: 'currentUser', missions: 'missions' })
  },

  data: function () {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        { value: 'typeName', text: 'Model', sortable: true },
        { value: 'type', text: 'Type', sortable: true },
        { value: 'description', text: 'Description', sortable: true },
        { value: 'updatedAt', text: 'Archive date', sortable: false },
        { value: 'actions', text: 'Actions', sortable: false }
      ],

      tableItems: this.missions,

      inputs: {
        displayForm: false
      }
    }
  },

  methods: {
    ...mapActions(['loadMissions', 'setCurrentMission']),

    missionListUpdatedHandler() {
      this.refreshTable()
    },

    async refreshTable() {
      this.tableItems = []

      let self = this
      if (this.$http != null) {
        try {
          for (let urlId of [
            'parametricstudyrequests',
            'constellationperformanceanalysisrequests',
            'deploymentrequests',
            'simulationrequests',
            'constellationoptimizationrequests',
            'constellationgenerationrequests',
            'constellationsimulationrequests'
          ]) {
            let response = await this.$http.get(
              this.getAPI(urlId + '/archives')
            )
            let newData = await response.data
            this.tableItems = [...this.tableItems, ...newData]
          }
        } catch (e) {
          self.displayMessage(
            'Error getting the archived missions list. ',
            e,
            'missionTableErrorDisplay',
            'error'
          )
        }
      }
    },

    getInfos(item) {
      return dataTools.getInfos(item)
    },

    resetCurrentMission() {
      // immediate effect
      this.$root.$emit('set-current-mission', null)
    },

    getCurrentFormAPI(item) {
      return item.typeName + 's'
    },

    getItemAPI(item) {
      return this.getAPI(this.getCurrentFormAPI(item))
    },

    // TODO this method is copied from forms, it should be but in tool file like data.js. Also copied in application layour
    getAPI(objectAPI) {
      return '/users/' + this.currentUser.id + '/' + objectAPI.toLowerCase()
    },

    getCurrentFormTitle() {
      return 'Archived missions'
    },

    getStringFields() {
      return ['displayedName', 'description']
    },

    getValueFields() {
      return []
    },

    getReferenceFields() {
      return []
    },

    getBooleanFields() {
      return []
    },

    getCustomFields() {
      return []
    },

    getDateFields() {
      return ['updatedAt']
    },

    removeIfNotUsedAsReference: function (item, index, button) {
      let self = this
      let objectName = item.name
      let objectId = item.id
      this.$http
        .delete(this.getItemAPI(item) + '/archives/' + item.id)
        .then(() => {
          self.successAlertDisplayed = true
          self.successAlertMessage = objectName + ' deleted'
          self.$root.$emit('delete-mission', objectId)
        })
        .catch((e) => {
          self.displayMessage(
            'Error deleting ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
          self.refreshTable()
        })
    },

    async removeAll() {
      let self = this
      try {
        for (let urlId of [
          'parametricstudyrequests',
          'constellationperformanceanalysisrequests',
          'deploymentrequests',
          'simulationrequests',
          'constellationoptimizationrequests',
          'constellationgenerationrequests',
          'constellationsimulationrequests'
        ]) {
          let response = await this.$http.delete(
            this.getAPI(urlId + '/archives')
          )
          let newData = await response.data
          this.tableItems = [...this.tableItems, ...newData]
        }
      } catch (e) {
        self.displayMessage(
          'Error deleting the archived missions. ',
          e,
          'missionTableErrorDisplay',
          'error'
        )
      }
    },

    getEnumProperties: function () {
      return { typeName: {}, type: {} }
    },

    clearForm() {},

    getCurrentFormType() {
      return null
    },

    displayEnumValue(exoData, field) {
      try {
        let desc = fieldsDescription[exoData.typeName]['properties'][field]
        if (exoData[field] && Array.isArray(exoData[field])) {
          return (
            '[' +
            exoData[field]
              .map((el) => desc['values'].find((val) => val.value === el).text)
              .join(', ') +
            ']'
          )
        } else if (exoData[field]) {
          return desc['values'].find((el) => el.value === exoData[field]).text
        }
      } catch (e) {
        return 'undefined'
      }
    }
  }
}
</script>
